import React, { useId } from 'react';
import SellerNavItem from './SellerNavItem';

export default function SellerNavSection({
  section,
  isExpanded,
  onToggle,
  expandedItemIds,
  onToggleItem,
  searchResult,
  isSearching,
  query,
  active,
  counts,
  alerts,
}) {
  const panelId = useId();
  const containsActive = active?.sectionId === section.id;
  const hasAlerts = section.items.some(item => alerts?.[item.alertKey] > 0);

  return (
    <div
      className={[
        'seller-nav-section',
        isExpanded ? 'seller-nav-section--expanded' : '',
        containsActive ? 'seller-nav-section--active-trail' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <button
        type="button"
        className="seller-nav-section__toggle"
        aria-expanded={isExpanded}
        aria-controls={panelId}
        onClick={onToggle}
      >
        <span className="seller-nav-section__icon" aria-hidden="true">
          <i className={section.icon}></i>
        </span>
        <span className="seller-nav-section__title">{section.title}</span>
        {hasAlerts && (
          <span
            className="seller-nav-section__alert-indicator"
            aria-label="New activity"
          ></span>
        )}
        <span className="seller-nav-section__chevron" aria-hidden="true">
          <i className="fa-solid fa-chevron-down"></i>
        </span>
      </button>
      {isExpanded && (
        <div
          className="seller-nav-section__items"
          id={panelId}
          role="region"
          aria-label={section.title}
        >
          <ul className="seller-nav-section__list">
            {section.items
              .filter(item => !isSearching || searchResult.matchingItemIds.has(item.id))
              .map(item => (
                <SellerNavItem
                  key={item.id}
                  item={item}
                  isExpanded={expandedItemIds.has(item.id)}
                  onToggle={() => onToggleItem(item.id)}
                  searchResult={searchResult}
                  isSearching={isSearching}
                  query={query}
                  active={active}
                  counts={counts}
                  alerts={alerts}
                />
              ))}
          </ul>
        </div>
      )}
    </div>
  );
}
